import React, { useState } from 'react';
import { FaChartBar, FaRoute, FaTimes } from 'react-icons/fa';

const Routes = () => {
  const [isVisible, setIsVisible] = useState(false);
  const check = true;

  const toggleStatsMenu = () => setIsVisible(!isVisible);

  return (
    <div>
      {/* Toggle Button */}
      <button
        className="flex items-center justify-center fixed bottom-[20px] right-[12px] w-11 h-11 p-2 bg-blue-900 border border-gray-700 rounded-full shadow-lg hover:bg-blue-800 transition"
        onClick={toggleStatsMenu}
      >
        <FaRoute className={'text-lg text-gray-300'} />
      </button>

      {check && isVisible && (
        <div className="fixed inset-0 flex z-40 items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[700px] max-w-[90%] max-h-[80vh] overflow-y-auto bg-gradient-to-br from-slate-900 to-gray-950 border border-gray-800 shadow-xl p-6 text-white">
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-300 text-lg hover:bg-red-600 font-bold rounded-full bg-red-700 w-7 h-7 flex items-center justify-center p-0"
              onClick={toggleStatsMenu}
            >
              <FaTimes />
            </button>

            <h3 className="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-center">
              <span className="flex items-center gap-2 text-gray-300">
                <FaRoute className={'text-blue-500'} />
                EFRO Mandatory Routes
              </span>
            </h3>

            {/* Routes Sections */}
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Scottish (EGPX) through Norway
                </h4>
                <div className="space-y-2">
                  <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                    ALOTI DCT TIBNO DCT EGAGO DCT OSLAV DCT BEGDO DCT BESLA DCT
                    MISMO DCT NEMGU
                  </p>
                  <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                    BEREP DCT KEKOD DCT OSMUM DCT SOLKA DCT OSS DCT BEGDO DCT
                    BESLA DCT MISMO DCT NEMGU
                  </p>
                  <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                    INBOB DCT DANKO DCT ULMUG DCT ROGED DCT GEVRU DCT SUN DCT
                    ELBOG DCT BESLA DCT MISMO DCT NEMGU
                  </p>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Amsterdam (EHAA) through Denmark
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  GREFI DCT DANKO DCT ULMUG DCT ROGED DCT GEVRU DCT SUN DCT
                  ELBOG DCT BESLA DCT MISMO DCT NEMGU
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Warsaw (EPWW) through Baltic or Sweden
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 mb-2 text-gray-200">
                  BOKSU DCT GUNTA DCT SOKVA DCT DOBAN DCT TEVRU Y75 NEPIX
                </p>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  PENOR DCT KOSKA DCT OTVEG DCT GODOB DCT NEPIX
                </p>
              </div>

              {/* Repeat for remaining routes */}
              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Bremen (EDWW) through Warsaw (EPWW) and Sweden
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  DEMUR N746 GORPI DCT LATVI DCT ELRID DCT EVLAN DCT OTVEG DCT
                  GODOB DCT NEPIX
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Bremen (EDWW) through Denmark
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  PIZID M105 AMRAK DCT VADIN DCT LABAN N873 ARS DCT BAKLA DCT
                  DIVEG DCT GODOB DCT NEPIX
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Polaris (ENOR) - Northern Norway
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  GOMAV DCT EXUTI DCT GITEV DCT TUGPU DCT OSLIT
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Reykjavik (BIRD) through Norway
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  IPTON DCT EVLED DCT OSMUM DCT SOLKA DCT OSS DCT BEGDO DCT
                  BESLA DCT MISMO DCT NEMGU
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  Tallinn (EETT)
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  INTOR DCT TEVRU Y75 NEPIX
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-pink-500 mb-2">
                  St Petersburg (ULLL)
                </h4>
                <p className="bg-gray-600/20 border border-gray-800 p-2 text-gray-200">
                  LEDUN DCT TEVRU Y75 NEPIX
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Routes;
